import * as React from 'react';
import { DayButtonProps } from 'react-day-picker';
import { DEAL_BUTTON_STATIC_STYLES } from './DatePickerDealButton.styles';
import { SearchIcon } from '../../../icons';

export interface DatePickerDealButtonProps extends DayButtonProps {
    /**
     * A price string that will be rendered for this day.
     */
    price?: string;

    /**
     * A callout message that will be rendered for this day.
     */
    calloutLabel?: string;

    /**
     * If `true`, the day will have the highlighted styling.
     * @default false
     */
    highlighted?: boolean;

    /**
     * If `true`, the day will have the selected styling.
     * @default false
     */
    selected?: boolean;
}

export function DatePickerDealButton(props: DatePickerDealButtonProps): React.JSX.Element | null {
    const { price, highlighted = false, calloutLabel, selected = false, day, modifiers, ...buttonProps } = props;

    // Ignore days outside the current month.
    if (modifiers.outside) {
        return null;
    }

    return (
        // eslint-disable-next-line react/button-has-type
        <button
            css={DEAL_BUTTON_STATIC_STYLES}
            data-deal-button={true}
            data-highlighted={highlighted || undefined}
            data-selected={selected || undefined}
            data-deal={Boolean(calloutLabel) || undefined}
            {...buttonProps}
        >
            <div>{day.date.getDate()}</div>
            {!price && <SearchIcon size="2xs" />}
            {price && <div data-deal-price={true}>{price}</div>}
            {calloutLabel && <div data-deal-callout={true}>{calloutLabel}</div>}
        </button>
    );
}
